import { useQuery } from '@tanstack/react-query';
import { API } from '../utils/api.utils';
import api from '../utils/api.utils';

export interface DraftVersion {
  draft_id: number;
  essay: string;
  created_at: number;
  id: number;
  prompt_id: number;
  prompt_text: string;
  word_count: number;
  draft_name: string;
  draft_status: string;
}

const fetchDraftVersionsByUniversity = async (universityId: number, promptId?: number): Promise<DraftVersion[]> => {
  const url = promptId 
    ? `${API.BASE_URL}/api/v1/draft-versions/?university_id=${universityId}&prompt_id=${promptId}`
    : `${API.BASE_URL}/api/v1/draft-versions/?university_id=${universityId}`;
  const response = await api.get(url);
  return response.data;
};

export const useDraftVersionsByUniversity = (universityId: number, promptId?: number, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['draft-versions', universityId, promptId],
    queryFn: () => fetchDraftVersionsByUniversity(universityId, promptId),
    enabled: enabled && !!universityId,
    staleTime: 0,
    gcTime: 10 * 60 * 1000, // 10 minutes - cache persists for 10 minutes
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnMount: false, // Don't refetch when component mounts if data exists
    refetchOnReconnect: false, // Don't refetch when reconnecting to network
  });
};
